<template>

  <span>
      <span class="down-Arrow" v-show="!active" @click="active = !active">&#9660;</span>
      <span class="up-Arrow" v-show="active" @click="active = !active">&#9650;</span>
      <md-content v-show="active" style="background-color: transparent;"><slot /></md-content>
  </span>

</template>

<script>
export default {
  name: "accordion",
  props: [],
  data() {
    return {
      active: true,
    }
  },
  created() {
    //this.$parent.accordions.push(this);
  }
}
</script>

<style lang="scss">
</style>